import { Component, Input, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-mgm-banner',
  templateUrl: './mgm-banner.component.html',
  styleUrl: './mgm-banner.component.scss'
})
export class MgmBannerComponent implements OnInit {
  @Input() canMinimize = false;
  isExpanded = true;
  imageSrc = '../../../../assets/images/share-puzzle.svg';
  isMobile = false;

  openModal = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkMobile();
  }

  ngOnInit() {
    this.checkMobile();
  }

  private checkMobile() {
    this.isMobile = window.innerWidth <= 600;
  }

  toggleBanner() {
    if (this.canMinimize) {
      this.isExpanded = !this.isExpanded;

      const delay = this.isExpanded ? 0 : 175;

      setTimeout(() => {
        this.imageSrc = this.isExpanded
          ? '../../../../assets/images/share-puzzle.svg'
          : '../../../../assets/images/small-invite.svg';
      }, delay);
    }
  }

  toggleModal() {
    this.openModal = !this.openModal;
  }
}
